import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CloseSvgIconComponent } from '@components/svg-icons/close-svg-icon/close-svg-icon.component';
import { LnPrimaryButtonComponent } from '@components/butons/ln-primary-button/ln-primary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-successful-order-card',
  imports: [CloseSvgIconComponent, LnPrimaryButtonComponent, TranslocoPipe],
  templateUrl: './successful-order-card.component.html',
  styleUrl: './successful-order-card.component.css',
})
export class SuccessfulOrderCardComponent {
  @Input({ required: true }) close!: boolean;
  @Input({ required: true }) tittle!: string;
  @Input({ required: true }) textBody!: string;
  @Output() closePressed = new EventEmitter<void>();
  closeButton() {
    this.closePressed.emit();
  }
}
